export const ADD_KEYPAIR = "ADD_KEYPAIR";
export const ADD_RUN = 'ADD_RUN';
export const ADD_BLOCKCHAIN = 'ADD_BLOCKCHAIN';
export const ADD_BIP = 'ADD_BIP';